const env = config.VUE_APP_ENV;
const basePath = config.VUE_APP_BACKEND_BASEPATH;
const orchestrationUrl = config.VUE_APP_ORCHESTRATION_URL || basePath;
const supersetBasePath = config.VUE_APP_SUPERSET_BASEPATH;
const processDefinitionId = "start-process";
const appVersion = "1.45.0";
export const settings = {
  api_url: `${basePath}`,
  orchestration_url: `${orchestrationUrl}`,
  api_query_url: `${basePath}/odm-dataservice/api/1/odm-dataservice/query/`,
  api_query_count_url: `${basePath}/odm-dataservice/api/1/odm-dataservice/queryCount/`,
  api_batch_query_count_url: `${basePath}/odm-dataservice/api/1/odm-dataservice/queryCount/batch/`,
  auth_anonymous_api_url: `${basePath}/odm-authentication/api/1/anonymous/token/?applicationName=TWDDistribution`,
  auth_api_url: `${basePath}/odm-authentication/api/1/odm-authentication/token/?applicationName=TWDDistribution`,
  env,
  processDefinitionId,
  appVersion,
  supersetBasePath: supersetBasePath,
  superset_api_url: `${supersetBasePath}/api/v1/`,
  adminConfig: {
    password: process.env.VUE_APP_SUPERSET_ADMINCONFIG_PASSWORD,
    username: process.env.VUE_APP_SUPERSET_ADMINCONFIG_USERNAME,
    provider: process.env.VUE_APP_SUPERSET_ADMINCONFIG_PROVIDER,
    refresh: process.env.VUE_APP_SUPERSET_ADMINCONFIG_REFRESH,
  },
  guestConfig: {
    user: {
      username: process.env.VUE_APP_SUPERSET_GUESTCONFIG_USER_USERNAME,
      first_name: process.env.VUE_APP_SUPERSET_GUESTCONFIG_USER_FIRSTNAME,
      last_name: process.env.VUE_APP_SUPERSET_GUESTCONFIG_USER_LASTNAME,
    },
    resources: [
      {
        type: process.env.VUE_APP_SUPERSET_GUESTCONFIG_RESOURCES_TYPE,
        id: process.env.VUE_APP_SUPERSET_GUESTCONFIG_RESOURCES_ID,
      },
    ],
    rls: [],
  },
  theme: config.VUE_APP_THEME|| process.env.VUE_APP_THEME,
  oidc: {
    enabled: config.VUE_APP_OIDC || process.env.VUE_APP_OIDC,
    issuerUrl: config.VUE_APP_OIDC_ISSUER_URL|| process.env.VUE_APP_OIDC_ISSUER_URL,
    clientId: config.VUE_APP_OIDC_CLIENT_ID|| process.env.VUE_APP_OIDC_CLIENT_ID,
  },
  AI: {
      // Active/désactive la validation IA des documents. Seule la valeur "false" la désactive :
      // variable absente = IA active
      VUE_APP_IA: config.VUE_APP_IA|| process.env.VUE_APP_IA,
      VUE_APP_VERIF_DOCUMENT_LINK_API: config.VUE_APP_VERIF_DOCUMENT_LINK_API|| process.env.VUE_APP_VERIF_DOCUMENT_LINK_API,
      VUE_APP_JWT_SECRET_KEY_VERIF_DOCUMENT_API: config.VUE_APP_JWT_SECRET_KEY_VERIF_DOCUMENT_API|| process.env.VUE_APP_JWT_SECRET_KEY_VERIF_DOCUMENT_API
  }
};
